import TrashIcon from "../../../assets/svg/TrashIcon";
import dateFormat, { ExpiryDateStatus } from "../../../utils/dateFormat";
import dayjs, { extend } from "dayjs";
import duration from "dayjs/plugin/duration";
import Logger from "../../../libs/Logger";
import { IApiKeyObjectType } from "../../../interfaces/apiKeysInterfaces";
import Modal from "@mecha/design-components/dist/src/components/Elements/Modal";
import DeleteApiKey from "./DeleteApiKeys";
import { useState } from "react";
import { Button } from "@mecha/design-components/dist/src/components/Elements/Button";
import { IconButton } from "@mecha/design-components/dist/src/components/Elements/IconButton";

interface Props {
  item: IApiKeyObjectType;
  handleDelete: (id: string) => void;
  index: number;
}

const ApiKeyItems = (props: Props) => {
  const log = new Logger({ module: "Settings", component: "ApiKeyItems" });
  log.trace({ props }, "(ApiKeyItems) - props in ApiKeyItems");
  const { item, handleDelete, index } = props;
  const { keyName: name, expiryDate, description, accessKeyId } = item;
  const [openDelete, setDelete] = useState(false);

  const { status } = dateFormat(expiryDate);
  log.debug(
    { status },
    "(ApiKeyItems) - status received from dateFormat function",
  );

  const calculateRelativeTime = expiryDate => {
    extend(duration);
    const durationRemaining = dayjs.duration(expiryDate.diff(dayjs()));
    //setting value of relative expiry date which will be shorter in length
    return `${Math.floor(
      durationRemaining.as("day"),
    )}d ${durationRemaining.hours()}h ${durationRemaining.minutes()}m`;
  };
  const relativeTime = calculateRelativeTime(dayjs(expiryDate));
  const absoluteTime = dayjs(expiryDate)?.format(
    "ddd DD MMM YYYY HH:mm:ss:Z A",
  );
  log.trace({ relativeTime }, "(ApiKeyItems) - relative time for expiry date");
  log.trace({ absoluteTime }, "(ApiKeyItems) - absolute time for expiry date");

  return (
    <div className="p-5 border dark:border-neutral-110 rounded-md flex flex-col gap-5 ">
      <div className="flex flex-row items-start justify-between gap-3">
        <div className="flex flex-col gap-2">
          <h1
            className={`text-lg font-medium text-primary-600 break-all ${
              status === "Expired"
                ? "dark:text-dark-n-500 text-light-n-500"
                : ""
            }`}
          >
            {name}
          </h1>
          <div className="flex flex-row items-start gap-2">
            <p className="dark:text-custom-420 text-custom-410 break-keep	text-nowrap	font-normal w-max">
              Key ID:
            </p>
            <p
              className={`dark:text-custom-2060 text-wrap break-all ${
                status === "Expired"
                  ? "dark:text-dark-n-500 text-light-n-500"
                  : ""
              }`}
            >
              {accessKeyId}
            </p>
          </div>
          {description && (
            <div className="flex flex-col gap-3">
              {/* <p className="dark:text-custom-2060">{accessKeyId}</p> */}
              <p className="dark:text-custom-420 text-custom-410 break-all __text-api-key-description">
                {description}
              </p>
            </div>
          )}
        </div>
        <div className="flex flex-row items-center gap-2">
          <div className="flex flex-row gap-3 items-center">
            <IconButton
              color="default"
              size="sm"
              className={`__button-delete-api-key_${
                index + 1
              } aspect-square min-w-min`}
              onClick={() => setDelete(true)}
            >
              <TrashIcon className="text-red-500" />
            </IconButton>
          </div>
          {openDelete && (
            <Modal
              opened
              padding="sm"
              radius="lg"
              overlayColor="bg-black bg-opacity-60 dark:bg-dark dark:bg-opacity-80 z-modal"
              overlayOpacity={1}
              overlayClass="z-999"
              className="z-options mx-3"
              contentClassName="p-4 lg:p-8 md:w-[518px] xs:w-[335px] border-2 border-light-400 dark:border-dark-400 max-w-xl dark:bg-dark-800 bg-light-800 flex flex-col justify-between mecha-scroll-1"
              size="md"
              title="Delete this API key"
              titleClassName="text-mob-h4 md:text-web-h6 dark:text-dark-n-400 text-light-n-400 font-medium"
              onClose={() => {
                setDelete(false);
              }}
            >
              <DeleteApiKey
                name={name}
                expiryDate={expiryDate}
                setDelete={setDelete}
                apiKeyId={accessKeyId}
                handleDelete={handleDelete}
              />
            </Modal>
          )}
        </div>
      </div>
      <hr
        className={`border-t-2 dark:border-dark-800 border-light-800 w-full`}
      />
      <p
        className="dark:text-custom-420 text-custom-410  font-normal"
        title={status == ExpiryDateStatus.EXPIRES_IN ? absoluteTime : status}
      >
        {status == ExpiryDateStatus.EXPIRES_IN
          ? `Expires in ${relativeTime}`
          : status}
      </p>
    </div>
  );
};

export default ApiKeyItems;
